export const setSelectedPage = "SET_SELECTED_PAGE";